if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        this.buildQuickAddSummary(productElement);
      }

      // Belmont & Kensing customization.
      // The product section's `title` block renders the product title twice (an <h1>
      // followed by a linked <h2 class="h1">). When the whole product block is injected
      // into the quick-add popup, both titles appear. We remove the duplicate linked
      // title so the headline shows once. Dawn also hides the real description inside the
      // popup (via the .quick-add-hidden class), so we surface a short plain-text excerpt
      // of the real description plus a "View full details" link, without dumping the full
      // long description into the popup.
      buildQuickAddSummary(productElement) {
        const titleWrap = productElement.querySelector('.product__title');
        if (titleWrap) {
          const duplicateTitleLink = titleWrap.querySelector('a.product__title');
          if (duplicateTitleLink) duplicateTitleLink.remove();
        }

        if (!titleWrap || productElement.querySelector('.quick-add-summary')) return;

        const descriptionEl = productElement.querySelector('.product__description');
        const rawText = descriptionEl ? (descriptionEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
        const productUrl = productElement.getAttribute('data-url') || '';

        if (!rawText && !productUrl) return;

        const summary = document.createElement('div');
        summary.className = 'quick-add-summary';
        summary.style.cssText = 'margin:0.75rem 0 0.25rem;';

        if (rawText) {
          const words = rawText.split(' ');
          const excerpt = words.length > 28 ? words.slice(0, 28).join(' ') + '\u2026' : rawText;
          const excerptEl = document.createElement('p');
          excerptEl.className = 'quick-add-summary__excerpt';
          excerptEl.textContent = excerpt;
          excerptEl.style.cssText =
            'display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;margin:0 0 0.5rem;opacity:0.8;line-height:1.5;';
          summary.appendChild(excerptEl);
        }

        if (productUrl) {
          const link = document.createElement('a');
          link.className = 'quick-add-summary__link link';
          link.href = productUrl;
          link.textContent = 'View full details';
          link.style.cssText = 'display:inline-block;font-size:1.3rem;';
          summary.appendChild(link);
        }

        titleWrap.insertAdjacentElement('afterend', summary);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
